export const resolveAfter = <T = void>(ms: number, value: T): Promise<T> =>
  new Promise<T>((resolve) =>
    setTimeout(() => {
      resolve(value);
    }, ms)
  );

export const rejectAfter = (ms: number, error: Error): Promise<never> =>
  new Promise<never>((_resolve, reject) =>
    setTimeout(() => {
      reject(error);
    }, ms)
  );
